import React from 'react';
import { ClockIcon, FilesIcon, PencilLineIcon, RepeatIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { painPoints } from '../../data/content';
const icons = [ClockIcon, PencilLineIcon, FilesIcon, RepeatIcon];
export function PainSection() {
  return <section aria-labelledby="pain-heading" className="bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-149" data-mp="3m15n1syyx4mo">
      <div className="mx-auto max-w-5xl" data-id="element-150" data-mp="nj9vk3ubltza">
        <SectionHeading id="pain-heading" title={<>
              You Love Teaching PMU. <Accent data-id="element-152" data-mp="im06wqer9mci">But Preparing Every Class?</Accent>
            </>} body="That's where the hours disappear." data-id="element-151" data-mp="ni8i5spu0vee" />

        <ul className="mt-12 grid gap-4 sm:grid-cols-2" role="list" data-id="element-153" data-mp="8uvv1zkdmhlw">
          {painPoints.map((pain, index) => {
          const Icon = icons[index];
          return <li key={pain.title} className="flex items-start gap-4 rounded-[20px] bg-brand-ivory p-6 shadow-[0_20px_40px_-34px_rgba(24,45,42,0.45)]" data-id="element-154" data-mp="11j1gypn62cnb" data-mpi={index}>
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-brand-blush" data-id="element-155" data-mp="3gc2rvqk7ykon">
                  <Icon className="h-5 w-5 text-brand-gold-dark" strokeWidth={1.5} aria-hidden="true" data-id="element-156" data-mp="31ny3q72edgyh" />
                </span>
                <span data-id="element-157" data-mp="36l824c7rl2yg">
                  <span className="block font-display text-[1.35rem] font-bold leading-tight text-brand-charcoal" data-id="element-158" data-mp="36kg7b3lzr998">
                    {pain.title}
                  </span>
                  <span className="mt-1.5 block text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-159" data-mp="2wp4q8en41pyb">{pain.text}</span>
                </span>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-160" data-mp="2nogczm5jjtmh">
          Your PMU expertise deserves a <Accent data-id="element-161" data-mp="lwk2mfv40pta">teaching system</Accent> that supports it.
        </p>
      </div>
    </section>;
}